import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const useFetchDataOnLocationChange = (fetchFunction: () => void, pathname: string) => {
  const location = useLocation()

  const isActiveRoute = location.pathname === pathname

  useEffect(() => {
    if (isActiveRoute) {
      fetchFunction()
    }
  }, [fetchFunction, isActiveRoute])
}
